import styled, { css } from "styled-components";
import { useState } from "react";
import { fadeIn } from "../styles/animations";
import { ModalProps, useModal } from "../utils/useModal";

const ImageModal = ({ hash, payload }: ModalProps) => {
  const { offModal } = useModal();
  const [close, setClose] = useState(false);

  const closeModal = () => {
    setClose(true);
    setTimeout(() => {
      offModal(hash);
    }, 150);
  };

  return (
    <Wrapper $close={close}>
      <div>
        <img src={`/assets/${payload.id}`} alt="thumbnail"></img>
        <CloseButton onClick={closeModal}>
          <span></span>
          <span></span>
          <span></span>
        </CloseButton>
      </div>
    </Wrapper>
  );
};

export default ImageModal;

const Wrapper = styled.div<{ $close: boolean }>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  animation: ${fadeIn} 0.25s forwards ease-in-out;

  ${({ $close }) =>
    $close &&
    css`
      opacity: 0;
    `}

  img {
    width: 100%;
    height: 100%;
  }
`;

const CloseButton = styled.div`
  position: absolute;
  width: 36px;
  height: 24px;
  top: 20px;
  right: 20px;
  cursor: pointer;

  &,
  span {
    display: inline-block;
    transition: all 0.6s cubic-bezier(0.165, 0.84, 0.44, 1);
    box-sizing: border-box;
  }

  span {
    position: absolute;
    left: 0;
    width: 100%;
    height: 2px;
    background-color: var(--white);
    border-radius: 4px;
  }

  span:nth-of-type(1) {
    top: 0;
  }

  span:nth-of-type(2) {
    top: 11px;
  }

  span:nth-of-type(3) {
    bottom: 0;
  }

  span:nth-of-type(1) {
    -webkit-transform: translateY (11px) rotate (-45deg);
    transform: translateY(11px) rotate(-45deg);
  }

  span:nth-of-type(2) {
    opacity: 0;
  }

  span:nth-of-type(3) {
    -webkit-transform: translateY(-11px) rotate(45deg);
    transform: translateY(-11px) rotate(45deg);
  }
`;
